<template>
  <b-table show-empty striped hover class="aco-table"
           :items="products" :fields="productFields">
    <template slot="empty">
      <div class="text-center">{{ $t('noResults') }}</div>
    </template>
    <template v-slot:cell(show_details)="row">
      <router-link :to="{ name: 'ProductDetails', params: { source: row.item.source, sourceId: row.item.sourceId }}">
        <b-button size="sm" class="py-0">{{ $t('details') }}</b-button>
      </router-link>
    </template>
  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ProductList',
    extends: BaseComponent,

    created: function () {
      this.$store.dispatch('products/getProducts')
    },

    computed: {
      ...mapGetters('products', ['products']),
      productFields () {
        return [
          { key: 'source', label: this.$t('source'), tdClass: 'text-nowrap',formatter: value => this.translateAlternatives('productSources', value)  },
          { key: 'ean', label: this.$t('ean'), tdClass: 'text-nowrap' },
          { key: 'site', label: this.$t('site'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('sites', value) },
          { key: 'name', label: this.$t('name'), tdClass: 'text-nowrap' },
          { key: 'bundledProducts', label: this.$t('bundle'), tdClass: 'text-nowrap', formatter: 'isBundleProduct' },
          { key: 'productForm', label: this.$t('productForm'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('productForms', value) },
          { key: 'productType', label: this.$t('productType'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('productTypes', value) },
          { key: 'componentType', label: this.$t('componentType'), tdClass: 'text-nowrap', formatter: value => value ? this.$t(`componentTypes.${value}`) : '' },
          { key: 'forSale', label: this.$t('forSale'), tdClass: 'text-nowrap', formatter: 'translateBooleans' },
          { key: 'licenseType', label: this.$t('licenseType'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('licenseTypes', value)  },
          { key: 'show_details', label: '' }
        ]
      }
    }
  }
</script>
